/** Временный показ коворкинга только этому клиенту. */
export const COWORKING_PREVIEW_CUSTOMER_ID = 107480;

export const canPreviewCoworking = (customerId?: number): boolean =>
    customerId === COWORKING_PREVIEW_CUSTOMER_ID;
